import * as React from 'react';
import { toast } from 'react-toastify';
import GoogleMap from './GoogleMap';
import * as DateHelpers from './DateHelpers';
import { useParams } from 'react-router-dom';
import { GetQuery } from './Shared';
import type { ScheduleRoutes } from './models/JobScheduleInterfaces';

const ScheduleDayMapData = () => {
    const [scheduleDateFormatted, setScheduleDateFormatted] = React.useState("");
    const [routes, setRoutes] = React.useState<ScheduleRoutes[]>([]);
    const [loading, setLoading] = React.useState(true);
    const { scheduleBranchId, scheduleDate } = useParams();

    React.useEffect(() => {
        window.scrollTo(0, 0);
        getScheduleAddresses();
    }, []);

    const getScheduleAddresses = async () => {
        const apiUrl = "GetScheduleDayJobAddresses?ScheduleBranchId=" + scheduleBranchId + '&ScheduleDate=' + scheduleDate;
        var result = await GetQuery(apiUrl);

        if (result.error) {
            toast.error("Error getting data!");
        } else {
            var dateFormatted = DateHelpers.formatDate(scheduleDate);
            setScheduleDateFormatted(dateFormatted);
            setRoutes(result.data);
            setLoading(false);
        } 
    }

    let map = <GoogleMap routes={routes} />

    const renderDetails = (
        <div>
            {map}
        </div>
    );

    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderDetails;

    return (
        <div>
            <h1>Jobs scheduled for {scheduleDateFormatted}</h1>
            {contents}
        </div>
    );

};

export default ScheduleDayMapData;
